// src/components/ui/empty-state.jsx
import * as React from "react"
import { cn } from "@/lib/utils"
import { Button } from "./button"

const EmptyState = React.forwardRef(
  ({ 
    className, 
    icon: Icon, 
    title, 
    description, 
    action,
    actionLabel,
    onAction,
    ...props 
  }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center py-12 px-6 text-center",
          className
        )}
        {...props}
      >
        {Icon && (
          <div className="w-12 h-12 mb-4 text-[#6a6a6a]">
            <Icon className="w-full h-full" />
          </div>
        )}
        {title && (
          <h3 className="text-base font-semibold text-white mb-2">
            {title}
          </h3>
        )}
        {description && (
          <p className="text-sm text-[#a0a0a0] mb-6 max-w-sm">
            {description}
          </p>
        )}
        {(action || (actionLabel && onAction)) && (
          <div>
            {action || (
              <Button onClick={onAction}>
                {actionLabel}
              </Button>
            )}
          </div>
        )}
      </div>
    )
  }
)
EmptyState.displayName = "EmptyState"

export { EmptyState }